import { useEffect } from "react"
import { useAppDispatch, useAppSelector } from "@hooks/app"
import { getEventSetting, getEventTeamTypes, getEventDonationSubpage, IInitialState } from "@states/slices/event"
import { getSetting, IInitialState as ISettingInitialState } from "@states/slices/setting"
import { useRouter } from "next/router"

interface IuseGetEventSetting {
  (setErrorMessage?: (string) => void): { EventData: IInitialState, SettingData: ISettingInitialState }
}

const useGetEventSetting: IuseGetEventSetting = (setErrorMessage) => {
  const router = useRouter()
  const { slug } = router.query

  const dispatch = useAppDispatch()
  const EventData = useAppSelector((state) => state.event)
  const SettingData = useAppSelector((state) => state.setting)

  useEffect(() => {
    if (slug && (!EventData.loaded || (EventData.loaded && EventData.data.slug !== slug))) {
      dispatchGetEventSetting(slug as string)
    }
    dispatchGetSetting()
  }, [])

  const dispatchGetEventSetting = async (slug: string) => {
    try {
      let settingData = await dispatch(getEventSetting(slug)).unwrap()
      if (settingData?.hasOwnProperty("id")) {
        dispatch(getEventTeamTypes(settingData.id.toString())).unwrap()
        dispatch(getEventDonationSubpage(settingData.id.toString()))
          .unwrap()
          .catch((error) => console.log(error))
      }
    } catch (error) {
      if (error?.data?.message && setErrorMessage) setErrorMessage(error.data.message)
    }
  }

  const dispatchGetSetting = async () => {
    try {
      await dispatch(getSetting()).unwrap()
    } catch (error) {
      if (error?.data?.message && setErrorMessage) setErrorMessage(error.data.message)
    }
  }

  return { EventData, SettingData }
}

export default useGetEventSetting
